import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useForm, Controller, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import DropDown from 'components/Input/DropDown'
import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import { Input, Checkbox, Textarea, Button, Icon } from 'components/UI'
import { CreateBannersScheme } from '../../../../../../routing/utils/validators'
import PaymentPreferences from './PaymentPreferences'
import WithUploadBtn from './WithUploadBtn'

import { useAvailableCategories, useQuery } from '../../../../../../hooks'
import {
  selectClassBanner,
  selectErrorEditClassBanner,
  selectErrorMessageCreateBanner,
  selectIsLoadingCreateBanner,
  selectLoadingEditClassBanner,
  selectUserData,
} from 'routing/fetchingfunction/user/user.reducer'
import {
  createBanners,
  editClassBanner,
  getBanner,
  resetBanner,
  setCreateBannerStep,
  setStep,
} from 'routing/fetchingfunction/user/user.action'

import { MAX_UPLOADED_IMAGES, MAX_UPLOADED_VIDEOS } from 'constants/upload'
import { handleNumberInputWheel } from '../../../../../../helpers'
import store from 'store'
import Tooltip from 'components/toolTip/ToolTip'
import { BACKEND_REGISTRATION_CODES } from 'constants'

const CreateForm = ({ onCancel, className = '' }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const query = useQuery()

  const userData = useSelector(selectUserData)

  const isLoading = useSelector(selectIsLoadingCreateBanner)
  const isEditLoading = useSelector(selectLoadingEditClassBanner)
  const error = useSelector(selectErrorMessageCreateBanner)
  const editError = useSelector(selectErrorEditClassBanner)
  const classBanner = useSelector(selectClassBanner)
  const [submissionError, setSubmissionError] = useState(null)

  const methods = useForm({
    defaultValues: {
      class_banner_category: null,
      is_public: true,
      price_per_class: '',
      payment_preferences: [],
      description: '',
      keywords: '',
      video: [],
      images: [],
    },
    resolver: yupResolver(CreateBannersScheme),
  })

  const {
    formState: { errors },
    setValue,
    handleSubmit,
    control,
    watch,
  } = methods

  const [originalImages, setOriginalImages] = useState([])

  const { formattedClassBannerCategories, classBannerCategories, loading, banners } =
    useAvailableCategories()
  const categories = useMemo(() => {
    const array = [...formattedClassBannerCategories]

    if (classBanner) {
      array.push({
        label: classBanner.class_banner_category.name,
        value: classBanner.class_banner_category.id,
      })
    }

    return array
  }, [formattedClassBannerCategories, classBanner])

  const categories_ = loading ? [{ label: 'Loading...', value: null }] : categories

  const keywords = watch('keywords')
  const description = watch('description')

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    } else {
      dispatch(
        setStep({
          step: BACKEND_REGISTRATION_CODES.COMPLETED,
          skipBackendUpdate: true,
        })
      )
    }
  }

  const handleFormSubmit = (data) => {
    const freshUserData = store.get('user_data')
    const userId = freshUserData?.id || freshUserData?.pk || userData?.id || userData?.pk
    if (!userId) {
      setSubmissionError('User not Available')
    }
    try {
      if (classBanner) {
        const formData = new FormData()

        const classBannerData = {
          active: classBanner.active,
          payment_preferences: data.payment_preferences,
          class_banner_category: data.class_banner_category,
          description: data.description,
          price_per_class: data.price_per_class,
          keywords: data.keywords,
          is_public: data.is_public,
        }

        const newImages = []
        const deletedImages = []
        let newImagesStartIndex = 0

        data.images.forEach((image) => {
          if (image.size) {
            newImages.push(image)
          } else if (image.original) {
            const deletedIndex = originalImages.findIndex(
              (originalImage) => originalImage.original === image.original
            )

            deletedImages.push(deletedIndex)
          }
        })

        newImagesStartIndex = originalImages.length - deletedImages.length

        if (newImagesStartIndex < 0) {
          newImagesStartIndex = 0
        }

        // newImages.forEach((image) => {
        //   newImagesStartIndex += 1

        //   formData.append(`picture_${newImagesStartIndex}`, image)
        // })

        // if (data.video[0] && data.video[0].size) {
        //   formData.append('cover_video', data.video[0])
        // }

        classBannerData.images = data.images
          .map((image, index) => {
            if (!deletedImages.find((deleteImageIndex) => deleteImageIndex === index)) {
              return index + 1
            }

            return null
          })
          .filter(Boolean)
          .map((image) => {
            return `picture${image}`
          })

        formData.append('class_banner', JSON.stringify(classBannerData))

        dispatch(
          editClassBanner({
            id: classBanner.classbanner_hash_1,
            data: formData,
          })
        ).then((response) => {
          if (!response.error) {
            dispatch(setCreateBannerStep(2))
          }
        })

        return
      }

      const formData = new FormData()
      const class_banner = {
        creator: userId,
      }

      for (let key in data) {
        if (key === 'video' || key === 'images') {
          continue
        }

        class_banner[key] = data[key]
        // formData.append(`class_banner[${key}]`, data[key])
      }

      const strinClassBanner = JSON.stringify(class_banner)

      formData.append('class_banner', strinClassBanner)
      formData.append('cover_video', data.video[0])

      data.images.forEach((image, index) => {
        formData.append(`cover_image`, image)
      })

      // dispatch(createBanners(formData)).then((response) => {
      //   if (!response.error) {
      //     if (response.payload.classbanner_hash_1) {
      //       navigate(`${location.pathname}?id=${response.payload.classbanner_hash_1}`, {
      //         replace: true,
      //       })
      //     }
      //   }
      // })

      console.log(Object.fromEntries(formData))

      dispatch(createBanners(formData))
        .unwrap()
        .then(() => {
          console.log('banner created successfully')
          // dispatch()
          // dispatch(setCreateBannerStep(2))

          // setStep({
          //   step: 'profile_completed',
          //   skipBackendUpdate: true,
          // })
        })
        .catch((e) => {
          console.log(e)
        })
    } catch (e) {
      // console.error(e)
    }
  }

  useEffect(() => {
    if (classBanner) {
      setValue('is_public', classBanner.is_public || false)
      setValue('price_per_class', classBanner.price_per_class || '')
      setValue(
        'payment_preferences',
        (classBanner.payment_preferences || []).map((preference) => preference.id)
      )
      setValue('description', classBanner.description || '')
      setValue('keywords', classBanner.keywords || '')
      setValue('class_banner_category', classBanner.class_banner_category.id || null)
      setValue('video', classBanner.cover_video ? [classBanner.cover_video] : [])
      setValue('images', classBanner.images || [])

      setOriginalImages(classBanner.images || [])
    }
  }, [setValue, classBanner])

  useEffect(() => {
    if (params.id || query.get('id')) {
      dispatch(getBanner(params.id || query.get('id')))
    }
  }, [params])

  useEffect(() => {
    return () => {
      dispatch(resetBanner())
    }
  }, [])

  return (
    <div className={`w-full pt-6 px-4 max-w-2xl mx-auto ${className}`}>
      {(typeof error === 'string' || typeof editError === 'string') && (
        <ErrorMessageWithExclamation text={error || editError} className="mb-4" scroll />
      )}

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="mb-3">
            <label className="text-sm mb-1">Category</label>

            <Controller
              control={control}
              name="class_banner_category"
              render={({ field: { onChange, value } }) => (
                <DropDown
                  menuItems={categories_}
                  setValue={onChange}
                  placeholder="Select Category"
                  value={value}
                />
              )}
            />

            {errors.class_banner_category && (
              <ErrorMessageWithExclamation text={errors.class_banner_category.message} />
            )}
          </div>
          <div className="mb-3">
            <label className="text-sm mb-1">Price per class</label>
            <Controller
              control={control}
              name="price_per_class"
              render={({ field }) => (
                <Input
                  wrapperClassName="w-full"
                  placeholder="0"
                  leftAddon="€" //€ can be added in the future if needed
                  type="number"
                  className="without-arrows"
                  onWheel={handleNumberInputWheel}
                  {...field}
                />
              )}
            />
            {errors.price_per_class ? (
              <ErrorMessageWithExclamation text={errors.price_per_class.message} />
            ) : (
              <p className="text-xs text-[#F79009] mt-1">Class duration is 55 min.</p>
            )}
          </div>
          <div className="mb-3">
            <span className="inline-block text-sm mb-1">Payment Preferences</span>

            <Controller
              control={control}
              name="payment_preferences"
              render={({ field: { value, onChange } }) => (
                <PaymentPreferences value={value} onChange={onChange} />
              )}
            />

            {errors.payment_preferences && (
              <ErrorMessageWithExclamation text={errors.payment_preferences.message} />
            )}
          </div>
          <div className="mb-3 relative">
            <span className="absolute top-0 right-0">{description.length}/3000</span>
            <label className="text-sm mb-1">Description</label>
            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <Textarea rows={4} placeholder="Enter a description" {...field} />
              )}
            />
            {errors.description && (
              <ErrorMessageWithExclamation text={errors.description.message} />
            )}
          </div>
          <div className="mb-3 relative">
            <span className="absolute top-0 right-0">{keywords.length}/150</span>
            <label className="text-sm mb-1">Keywords</label>

            <Controller
              control={control}
              name="keywords"
              render={({ field }) => <Textarea rows={4} placeholder="Keywords" {...field} />}
            />

            {errors.keywords ? (
              <ErrorMessageWithExclamation text={errors.keywords.message} />
            ) : (
              <p className="text-xs text-[#F79009] mt-1">
                Define keywords separated by commas to help students find your job post. Keywords
                are hidden.
              </p>
            )}
          </div>
          <div className="mb-3">
            <Controller
              control={control}
              name="video"
              render={({ field }) => (
                <>
                  <label className="text-sm mb-1">
                    Video ({field.value.length}/{MAX_UPLOADED_VIDEOS}) Video introduction
                    (mandatory): upload a front-facing video clearly showing your face (no
                    slideshows, screens, or backgrounds)
                  </label>
                  <WithUploadBtn type="video" {...field} />
                </>
              )}
            />
            <Controller
              control={control}
              name="center_video"
              render={({ field: { value, onChange } }) => (
                <Checkbox
                  labelClassName=" text-[#F79009] text-xs "
                  label="crop and centre your face"
                  wrapperClassName="mt-2"
                  checked={value}
                  onChange={onChange}
                />
              )}
            />

            {errors.video && <ErrorMessageWithExclamation text={errors.video.message} />}
          </div>
          <div className="mb-3">
            <Controller
              control={control}
              name="images"
              render={({ field }) => (
                <>
                  <label className="text-sm mb-1">
                    Image ({field.value.length}/{MAX_UPLOADED_IMAGES})
                  </label>
                  <WithUploadBtn type="images" {...field} />
                </>
              )}
            />
            <Controller
              control={control}
              name="is_public"
              render={({ field: { value, onChange } }) => (
                <Checkbox
                  label="crop and centre your face"
                  labelClassName=" text-[#F79009] text-xs "
                  wrapperClassName="mt-2 mb-4"
                  checked={value}
                  onChange={onChange}
                />
              )}
            />

            {errors.images && <ErrorMessageWithExclamation text={errors.images.message} />}
          </div>
          <div className="relative p-0">
            <Button
              className="w-full h-[44px] font-semibold"
              type="submit"
              isLoading={isLoading || isEditLoading}
            >
              Complete Banner Setup
            </Button>
            <span className="top-1/2 cursor-pointer absolute -translate-y-1/2  ml-5">
              <Tooltip
                text={`Please be aware that the banner will be inactive until the teaching hours are set in the calendar. After you can activate the banner in settings.`}
              >
                <Icon name={'info-icon'} />
              </Tooltip>
            </span>
          </div>

          {/* {banners?.length > 0 && (
            <div className="text-center">
              <Button
                className="mt-1 bg-transparent !text-[#F79009] font-bold"
                type="button"
                onClick={handleCancel}
              >
                Skip for Later{' '}
              </Button>
            </div>
          )} */}
        </form>
      </FormProvider>
    </div>
  )
}

export default React.memo(CreateForm)
